var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51988 16C3.51988 9.10748 9.10737 3.52 15.9999 3.52C22.8924 3.52 28.4799 9.10748 28.4799 16C28.4799 22.8925 22.8924 28.48 15.9999 28.48C9.10737 28.48 3.51988 22.8925 3.51988 16ZM15.9999 2.88C8.75391 2.88 2.87988 8.75402 2.87988 16C2.87988 23.246 8.75391 29.12 15.9999 29.12C23.2459 29.12 29.1199 23.246 29.1199 16C29.1199 8.75402 23.2459 2.88 15.9999 2.88ZM14.3999 16C14.3999 16.8837 15.1162 17.6 15.9999 17.6C16.8835 17.6 17.5999 16.8837 17.5999 16C17.5999 15.1163 16.8835 14.4 15.9999 14.4C15.1162 14.4 14.3999 15.1163 14.3999 16ZM15.6799 13.7827C14.5943 13.938 13.7599 14.8715 13.7599 16C13.7599 17.2371 14.7628 18.24 15.9999 18.24C16.503 18.24 16.9674 18.0741 17.3414 17.794L17.3736 17.8263L22.898 23.3506C23.023 23.4755 23.2256 23.4755 23.3505 23.3506C23.4755 23.2256 23.4755 23.023 23.3505 22.898L17.8262 17.3737L17.7939 17.3415C18.074 16.9675 18.2399 16.5031 18.2399 16C18.2399 14.8715 17.4054 13.938 16.3199 13.7827V6.72C16.3199 6.54327 16.1766 6.4 15.9999 6.4C15.8232 6.4 15.6799 6.54327 15.6799 6.72V13.7827Z",
    fill: "#404948"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.90a3df0bef109c0ee8eb2fc350520f38.svg";
export { ForwardRef as ReactComponent };